import React from 'react'
import { AutocompleteInput, TabbedForm } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { useCustomersOptionList } from './useCustomersOptionList'
import LocationFormTab from './eventsFormTabs/LocationTab/LocationFormTab'
import { Create } from 'react-admin'
import VirtualFormTab from './eventsFormTabs/ExperienceTab/VirtualFormTab'
import EventCreateCustomToolbar from 'ui-shared/CustomToolbars/EventCreateCustomToolbar'
import BaseProductTab from './eventsFormTabs/BaseProductTab/BaseProductTab'
import DrinksFormTab from './eventsFormTabs/DrinkTab/DrinksFormTab'
import PhysicalFormTab from './eventsFormTabs/ExperienceTab/PhysicalFormTab'
import FoodFormTab from './eventsFormTabs/FoodTab/FoodFormTab'
import GeneralTab from './eventsFormTabs/GeneralTab'
import ProfessionalsTab from './eventsFormTabs/ProfessionaTab/ProfessionalsTab'
import { yupResolver } from '@hookform/resolvers/yup'
import { eventVS } from 'services/validations/operations/events'

const EventCreate: React.FC = () => {
  const customersList = useCustomersOptionList()
  return (
    <SectionWrapper>
      <Create>
        <TabbedForm
          toolbar={<EventCreateCustomToolbar />}
          resolver={yupResolver(eventVS)}
        >
          <GeneralTab>
            <AutocompleteInput
              style={{ width: '256px' }}
              source="customer"
              label="form.fields.email"
              choices={customersList}
            />
          </GeneralTab>

          <ProfessionalsTab />

          <DrinksFormTab />

          <FoodFormTab />

          <VirtualFormTab />

          <PhysicalFormTab />

          <LocationFormTab />

          <BaseProductTab product="music" />

          <BaseProductTab product="rent" />
        </TabbedForm>
      </Create>
    </SectionWrapper>
  )
}

export default EventCreate
